module.exports = __webpack_public_path__ + "static/media/node-js.62e0865f.svg";